import * as React from "react";
import {SliderControlComponentProps} from "../../types/types";
import './sliderControl.component.scss';

export const SliderControlComponent = ( {currentValue, onChange, theme, name, max, min}: SliderControlComponentProps ) => {

    const getValuePosition = () => {
        return Number( ((currentValue - min) * 100) / (max - min) );
    }

    return (<div className={`slider-wrapper ${theme}`}>
        <input type="range" min={min} max={max} name={name} value={currentValue} className="slider" onChange={(event => onChange( event ))}/>
        <div className={"slider-value"} style={{left: `calc(${getValuePosition()}% + (${8 - getValuePosition() * 0.15}px))`}}>{currentValue}</div>
    </div>);
}
